import { inject, Injectable } from '@angular/core';
import { Query } from '@datorama/akita';

import { TrialInsightsState } from './trial-insights-store.model';
import { TrialInsightsStore } from './trial-insights.store';

@Injectable({ providedIn: 'root' })
export class TrialInsightsQuery extends Query<TrialInsightsState> {
  protected store: TrialInsightsStore;

  constructor() {
    const store = inject(TrialInsightsStore);

    super(store);

    this.store = store;
  }
}
